// AUPRÉA — Admin RGPD : liste et traitement des demandes
import { useEffect, useState } from "react";
import axios from "axios";
import { C, Btn, Spinner, Textarea } from "./shared";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

const TYPE_LABEL = {
  acces: "Accès", rectification: "Rectification", effacement: "Effacement",
  portabilite: "Portabilité", opposition: "Opposition", autre: "Autre",
};

export const RgpdDemandes = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openId, setOpenId] = useState(null);
  const [reponse, setReponse] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const t = localStorage.getItem("auprea_token");
      const r = await axios.get(`${API}/admin/rgpd-demandes`, { headers: { Authorization: `Bearer ${t}` } });
      setItems(r.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const traiter = async (id) => {
    try {
      const t = localStorage.getItem("auprea_token");
      await axios.post(`${API}/admin/rgpd-demandes/${id}/traiter`, { reponse },
                       { headers: { Authorization: `Bearer ${t}` } });
      setOpenId(null); setReponse(""); load();
    } catch (e) { console.error(e); }
  };

  if (loading) return <Spinner />;

  const ouvertes = items.filter(x => x.statut === "ouverte");
  const traitees = items.filter(x => x.statut === "traitee");

  return (
    <div data-testid="rgpd-admin-page">
      <div style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap" }}>
        <div style={{ padding: 14, background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 10, minWidth: 180 }}>
          <div style={{ fontSize: 10, color: C.muted, textTransform: "uppercase", letterSpacing: ".07em", fontWeight: 700 }}>Demandes ouvertes</div>
          <div style={{ fontSize: 26, fontWeight: 700, color: C.red }}>{ouvertes.length}</div>
        </div>
        <div style={{ padding: 14, background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 10, minWidth: 180 }}>
          <div style={{ fontSize: 10, color: C.muted, textTransform: "uppercase", letterSpacing: ".07em", fontWeight: 700 }}>Traitées</div>
          <div style={{ fontSize: 26, fontWeight: 700, color: C.green }}>{traitees.length}</div>
        </div>
      </div>

      {!items.length ? (
        <div style={{ textAlign: "center", padding: 40, color: C.muted, fontSize: 13 }}>Aucune demande RGPD pour l'instant.</div>
      ) : (
        <div style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr>{["Date", "ID", "E-mail", "Type", "Message", "Statut", ""].map(h => (
                <th key={h} style={{ padding: "10px 14px", textAlign: "left", fontSize: 10, fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: ".07em", borderBottom: `.5px solid ${C.border}`, background: C.gray2 }}>{h}</th>
              ))}</tr>
            </thead>
            <tbody>
              {items.map(d => (
                <tr key={d.id} style={{ borderBottom: `.5px solid ${C.border}` }}>
                  <td style={{ padding: "10px 14px", fontSize: 11, color: C.mid }}>{(d.created_at || "").slice(0, 10)}</td>
                  <td style={{ padding: "10px 14px", fontFamily: "monospace", fontSize: 11 }}>{d.id}</td>
                  <td style={{ padding: "10px 14px" }}>
                    <div style={{ fontWeight: 600 }}>{d.nom || "—"}</div>
                    <div style={{ fontSize: 11, color: C.mid }}>{d.email}</div>
                  </td>
                  <td style={{ padding: "10px 14px" }}>
                    <span style={{ padding: "2px 8px", borderRadius: 10, background: C.navylt, fontSize: 11, fontWeight: 600, color: C.navy }}>{TYPE_LABEL[d.type] || d.type}</span>
                  </td>
                  <td style={{ padding: "10px 14px", fontSize: 12, color: C.mid, maxWidth: 350 }}>{d.message}</td>
                  <td style={{ padding: "10px 14px" }}>
                    {d.statut === "ouverte" ? (
                      <span style={{ padding: "2px 8px", borderRadius: 10, background: C.redlt, color: C.red, fontSize: 11, fontWeight: 600 }}>Ouverte</span>
                    ) : (
                      <span style={{ padding: "2px 8px", borderRadius: 10, background: C.greenlt, color: C.green, fontSize: 11, fontWeight: 600 }}>Traitée</span>
                    )}
                  </td>
                  <td style={{ padding: "10px 14px" }}>
                    {d.statut === "ouverte" && <Btn small variant="gold" onClick={() => { setOpenId(d.id); setReponse(""); }} data-testid={`rgpd-traiter-${d.id}`}>Traiter</Btn>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {openId && (
        <div onClick={() => setOpenId(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", borderRadius: 12, padding: 24, maxWidth: 560, width: "90%" }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: C.navy, marginBottom: 14 }}>Traiter la demande {openId}</div>
            <Textarea placeholder="Réponse / notes de traitement…" value={reponse} onChange={(e) => setReponse(e.target.value)} rows={5} data-testid="rgpd-reponse" />
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 14 }}>
              <Btn onClick={() => setOpenId(null)}>Annuler</Btn>
              <Btn variant="gold" onClick={() => traiter(openId)} data-testid="rgpd-confirm-traiter">Marquer traitée</Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
